export default {"src":"/_next/static/media/money-back-guarantee.27fc1ace.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};